import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { change_application_status, get_all_active_applications } from '../api/applicationsApi';
import { toast } from 'react-toastify';
import { UsersApplicationsListInterface } from '../../../modules/accounts/components/settings/SettingsModel';
import { KTIcon, KTSVG } from '../../../../_metronic/helpers';
import { permissionCheck } from '../../../helper-functions/PermissionCheck';
var user_application_create,user_application_update,user_application_delete,user_application_view,user_application_activity_log;
function ActiveUsersApplicationsList() {
    const [applicationList, setApplicationList] = useState<UsersApplicationsListInterface[]>([]);
    const [selectedApplication, setSelectedApplication] = useState<UsersApplicationsListInterface | null>(null)
    const [searchInput, setSearchInput] = useState('');
    const [selectedItemsPerPage, setSelectedItemsPerPage] = useState(10); // Step 1: State variable for items per page
    const [sortBy, setSortBy] = useState<{ key: string, ascending: boolean } | null>(null); // State variable for sorting
    const [currentPage, setCurrentPage] = useState(1);
    user_application_create = Boolean(permissionCheck('user-application-create'));
    user_application_view = Boolean(permissionCheck('user-application-view'));
    const navigate = useNavigate();
    const [visibleData, setVisibleData] = useState<UsersApplicationsListInterface[]>([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const { data, isLoading, isError } = useQuery('get_all_active_applications', get_all_active_applications, { refetchOnWindowFocus: false });
    useEffect(() => {
      if (data) {
        // Convert object to array
        const applicationsArray:any= Object.values(data.data);
        setApplicationList(applicationsArray);
      }
    }, [data]);    
    const itemsPerPageOptions = [10, 20, 30, 50, 100]; // Step 2: Options for items per page
    const totalItems = applicationList.length;
    const totalPages = Math.ceil(totalItems / selectedItemsPerPage); // Update total pages based on selected items per page
    useEffect(() => {
      if (applicationList.length > 0) {
        let sortedData = [...applicationList];
    
        if (sortBy) {
          sortedData.sort((a, b) => {
            const key = sortBy.key;
    
            // Handle number sorting (e.g., "status")
            if (typeof a[key] === 'number' && typeof b[key] === 'number') {
              return sortBy.ascending ? a[key] - b[key] : b[key] - a[key];
            }
    
            // Handle date sorting (e.g., "created_at" or "updated_at")
            if (key.includes('_at') && typeof a[key] === 'string' && typeof b[key] === 'string') {
              return sortBy.ascending
                ? new Date(a[key]).getTime() - new Date(b[key]).getTime()
                : new Date(b[key]).getTime() - new Date(a[key]).getTime();
            }
    
            // Handle string sorting (default case)
            const aValue = (a[key] || '').toString().toLowerCase();
            const bValue = (b[key] || '').toString().toLowerCase();
            return sortBy.ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
          });
        }
    
        // Update visible data with pagination
        setVisibleData(
          sortedData.slice(
            (currentPage - 1) * selectedItemsPerPage,
            currentPage * selectedItemsPerPage
          )
        );
      }
    }, [applicationList, sortBy, currentPage, selectedItemsPerPage]);
    const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
      const searchTerm = e.currentTarget.value.toLowerCase();
      setSearchInput(searchTerm);
      // Convert object to array
      const applicationsArray: any = Object.values(data?.data || {});
      // Safeguard against invalid or empty data
      const filteredItems = applicationsArray.filter((application: any) => {
        return (
          application.application_name?.toLowerCase().includes(searchTerm) ||
          application.organization_name?.toLowerCase().includes(searchTerm)
        );
      });
      setApplicationList(filteredItems);
    };    
    const handleChangeApplicationStatus = useMutation((id: number) => {
      return change_application_status(id)
        .then((response) => {
          toast.error(response.message, {
            position: 'top-right',
            autoClose: 3000,
          })
          get_all_active_applications()
            .then((data) => {
              setApplicationList(data.data)
            })
            .catch((error: any) => {
              if (error.response) {
                const errorMessage = error.response.data.message
                toast.error(errorMessage, {
                  position: 'top-right',
                  autoClose: 2000,
                })
              }
            })
        })
        .catch((error) => {
          if (error.response) {
            const errorMessage = error.response.data.message
            toast.error(errorMessage, {
              position: 'top-right',
              autoClose: 2000,
            })
          }
        })
    });
    // Handle Sort
    const handleSort = (key: string) => {
      setSortBy((prev) =>
        !prev || prev.key !== key
          ? { key, ascending: true } // Sort ascending for a new key
          : { key, ascending: !prev.ascending } // Toggle sorting for the same key
      );
    };    
    const handleNextPage = () => {
      if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
      }
    };
    const handlePreviousPage = () => {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    };
    const handleApplicationView = (application: any) => {
      navigate("/user-applications/view-application-details", { state: { application: application } });
    };
  const handleApplicationActivityLog = (application: any) => {
      navigate("/user-applications/activity-logs", {
        state: { application_id: application.id, flag:'Active' },
      });
    };
    return (
      <div className='card card-xxl-stretch mx-4 mb-5 mb-xl-10'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>List of Active Applications</span>
          </h3>
        </div>
        <div className='card-header border-0 pt-5'>
          {/* begin::Search */}
          <h3 className='card-title align-items-start flex-column'>
            <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
            <input
              data-toggle="tooltip" data-placement="bottom" title="Search a Application"
              type='text'
              data-kt-user-table-filter='search'
              className='form-control form-control-solid w-250px ps-14'
              placeholder='Search Application'
              value={searchInput}
              onChange={handleInputChange}
            />
          </h3>
          {/* end::Search */}
          {/* commenting for future use  */}
          {/* <div
            className='card-toolbar'
          >
            <h5 className='p-3'>Filter by:</h5>
            <div>
              <select
                className='form-select form-select-solid form-select-lg fw-bold'
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value=''>Filter by Status...</option>
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>
          </div> */}
        </div>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='min-w-150px'>Organisations Name <span onClick={() => handleSort('organization_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                  <th className='min-w-150px'>Applications Name <span onClick={() => handleSort('application_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                  <th className='min-w-150px'>Status <span onClick={() => handleSort('status')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                  {/* <th className='min-w-140px'>Updated By <span onClick={() => handleSort('updated_by_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th> */}
                  {
                    user_application_view ? (
                      <th className='min-w-100px text-center'>Actions</th>
                    ):null
                  }
                </tr>
              </thead>
              <tbody>
                {isError ? (
                  <tr>
                    <td>Error loading data. Please try again later.</td>
                  </tr>
                ) : isLoading ? (
                  <tr>
                    <td colSpan={6}>
                      <div className='text-center'>
                        <div className='spinner-border' role='status'>
                          <span className='visually-hidden'>Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : applicationList.length > 0 ? (
                  visibleData.map((application) => (
                    <tr key={application.id}>
                      <td>
                        <div className='d-flex align-items-center'>
                          <div className='d-flex justify-content-start flex-column'>
                            <h3 className='text-dark fw-bold fs-6'>
                              {application.organization_name}
                            </h3>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className='d-flex align-items-center'>
                          <div className='d-flex justify-content-start flex-column'>
                            <h3 className='text-dark fw-bold fs-6'>
                              {application.application_name}
                            </h3>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className='d-flex align-items-center'>
                          <div className='d-flex justify-content-start flex-column'>
                            <h3 className='fw-boldfs-6 badge badge-success'>
                              Active
                            </h3>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className='d-flex justify-content-center flex-shrink-0'>
                        {
                          user_application_view && (
                            <button
                            data-toggle="tooltip" data-placement="bottom" title="Switch Status"
                            onClick={() => handleApplicationView(application)}
                            className='btn btn-icon btn-light-dark btn-active-color-danger btn-sm m-2'
                          >
                            <KTIcon iconName='update-folder' className='fs-3' />
                          </button>
                          )
                        }
                        {
                          user_application_view && (
                            <button
                            data-toggle="tooltip" data-placement="bottom" title="Activity Logs"
                            onClick={() => handleApplicationActivityLog(application)}
                            className='btn btn-icon btn-light-dark btn-active-color-success btn-sm m-2'
                          >
                            <KTIcon iconName='book' className='fs-3' />
                          </button>
                          )
                        }
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>No Active Applications Available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className='card-footer d-flex justify-content-between py-4'>
          <div className='align-items-center row'>
            <div className='d-flex'>
              <div className='col-md-9 mt-5'><strong>Results Per Page:</strong></div>
              <select
                style={{ width: '60px' }}
                className='form-select form-select-md px-2 col-md-1'
                value={selectedItemsPerPage}
                onChange={(e) => setSelectedItemsPerPage(Number(e.target.value))}
              >
                {itemsPerPageOptions.map(option => (
                  <option key={option} value={option} className='p-3 '>{option}</option>
                ))}
              </select>
            </div>
          </div>
          <div className='d-flex justify-content-end'>
            {currentPage === 1 ? (
              <button
                className='btn btn-light'
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
            ) : (
              <button
                className='btn btn-primary'
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
            )}
            <button
              className='btn btn-primary ms-2'
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
        <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title'>Change Application Confirmation</h5>
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr061.svg'
                    className='svg-icon svg-icon-2x'
                  />
                </div>
              </div>
              <div className='modal-body'>
                {selectedApplication ? (
                  <>
                    <p className='mb-2'>
                      <span className='fw-bold fs-5'>Application Status:</span> {selectedApplication.is_active}
                    </p>
                  </>
                ) : null}
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  Close
                </button>
                <button
                  type='button'
                  className='btn btn-danger'
                  onClick={() => {
                    if (selectedApplication) {
                      handleChangeApplicationStatus.mutate(selectedApplication.id)
                    }
                  }}
                  data-bs-dismiss='modal'
                >
                  Update Application Status
                </button>
              </div>
            </div>
          </div>
        </div>
  
      </div>
    )
  };
  
export default ActiveUsersApplicationsList